<template>
  <div v-if="currentLandscape">
    <lm-actor-select
      ref="actorSelect"
      :selected-actor="currentActor || selectedActor"
      check-rights
    >
      Add feed to:
    </lm-actor-select>
    <feed-sources-picker ref="sourcePicker" v-model="type" />
  </div>
</template>

<script>
import FormHelper from '@/components/form/formHelper'
import {Events} from '@/lib/definitions'
import {mapGetters} from 'vuex'
import LmActorSelect from '@/components/form/LmActorSelect'
import FeedSourcesPicker from '@/components/modals/feedSources/FeedSourcesPicker'
export default {
  name: 'FeedSourceStep1',
  components: {FeedSourcesPicker, LmActorSelect},
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      type: null
    }
  },
  computed: {
    ...mapGetters(['selectedActor', 'getActorByID', 'currentLandscape']),
    currentActor() {
      const actorId = this.value.actorId
      return actorId ? this.getActorByID(actorId) : null
    }
  },
  watch: {
    type(newValue, oldValue) {
      if (newValue !== oldValue && this.value.source) {
        // Reset source
        this.$emit('input', {
          ...this.value,
          source: null,
          title: '',
          description: '',
          tags: null
        })
      }
      this.$nextTick(() => {
        if (this.$refs.actorSelect.data) this.$emit(Events.NEXT_STEP)
      })
    }
  },
  methods: {
    init() {
      // Public. Do not remove!!
    },
    validate() {
      return new Promise((resolve, reject) => {
        const r = FormHelper.validate([
          this.$refs.actorSelect,
          this.$refs.sourcePicker
        ])
        if (r) {
          this.$emit('input', {
            ...this.value,
            actorId: this.$refs.actorSelect.data,
            type: this.type
          })
          resolve()
        } else reject()
      })
    }
  }
}
</script>

<style scoped></style>
